fx.ns("desktop.print", class PhotoChoices extends desktop.common.photoimport.PhotoChoices {
    
	constructor()
	{
		super();

		this.effect = "vslidein";
	}

	onReady()
	{
		super.onReady();

        this.on("photo-extracted", this._onPhotoExtracted, fx.service("MediasUploader") );
        this.on("photo-extracted-started", this._onPhotoExtractedStarted, fx.service("MediasUploader") );
        this.on("photo-extracted-finished", this._onPhotoExtractedFinished, fx.service("MediasUploader") );
	}

    create(){

		let box = new fx.components.Box();

		box.addChild(new shared.component.Person(fx.get("assets").photoImportStep1), {width:200, height : 200, top : 0, left : "center"});

		let text = new fx.components.Text({text : fx.text("Sélectionnez vos photos depuis :"), className : "title"});
		box.addChild(text, {height:60, top : 220, left : "center"});

		this.hbox_main = new fx.components.HBox("sources");
        box.addChild(this.hbox_main, {height : 190, left : "center", top : 260});

		if (this._options.computer)
		{
			let computerBox = new fx.components.Box("computer-box");
			this.computerButton = new fx.components.IconButton( {icon: fx.assets.computer, filled : true, className:"computer" } )
			computerBox.addChild( this.computerButton , {width:120, top : 10, left : "center"});
			computerBox.addChild( new fx.components.Text(fx.text("Votre ordinateur")), {width : "100%", height : 20, bottom : 0, left : 0});
			this.hbox_main.addChild(computerBox, {width:150, height: 170});
		}

		if(this._options.google)
		{
			let googleBox = new fx.components.Box("google-box");
			this.googleButton = new fx.components.IconButton( {icon: fx.assets.google, filled : false, className:"google"} );
			googleBox.addChild( this.googleButton , {width:80, top:30, left : "center" });
			googleBox.addChild( new fx.components.Text(fx.text("Google")), {width : "100%", height : 20, bottom : 0, left : 0});
			this.hbox_main.addChild(googleBox, {width:120, height: 170});
		}

		this.addChild(box, { top : "center", width : "100%", height : 500});
    }

    _onPhotoExtractedStarted()
	{
		this.popup(new shared.popups.ExtractingPhotosPopup());
	}
    
    _onPhotoExtracted(e)
    {
		let photo = e.detail;
        
        let print = this.data.print.addPrint();

        let layout = this.data.layouts.getDefaultLayout();	
        if (layout)
            print.applyLayout( layout, this.data.print.pageWidth, this.data.print.pageHeight);

        print.photosComponents.getItemAt(0).content = photo.id;
    }

    _onPhotoExtractedFinished(e)
    {
        this.data.history.clear();

        this.data.event("show-editor");
    }

	close()
	{
		this.data.event("show-editor");
	}

});